import Suggestions from "./Suggestions";
import MessageWidget from "./MessageWidget";
import SenderWidget from "./SenderWidget";
import AgentSelector from "./AgentSelector"
import { AiResponseWidget } from "./AiResponseWidget";
import { useChatHistory } from "../ChatHistoryProvider";
import { getMainHeader } from "../userAssests";
import { useAgent } from "../AgentsContext"

const Main = () => {
  const { selectedChat } = useChatHistory();
    const { agents, selectedAgent } = useAgent();
    const utilizedAgentName = agents.find(agent => agent.id === selectedAgent)?.name || "No agent selected";

  return (
    <div className="flex max-w-full flex-1 flex-col h-screen">
      <main className="relative h-full w-full transition-width flex flex-col overflow-hidden items-stretch flex-1">
        <div className="flex-1 overflow-auto">
          <div className="h-full bg-gray-200 dark:bg-gray-800">
            {selectedChat? (          
            <p className="p-2 m-2 dark:text-[#e5e7eb] bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded inline-block">
              {utilizedAgentName}
            </p>):(
                <></>
            )
            }


            <div className="flex flex-col items-center text-sm bg-gray-200 dark:bg-gray-800">
              {!selectedChat ? (
                <div className="text-gray-800 w-full md:max-w-2xl lg:max-w-3xl md:h-full md:flex md:flex-col px-6 dark:text-gray-100">
                  {getMainHeader()}
                  <AgentSelector />
                  {/* <Suggestions /> */}
                </div>
              ) : (
                selectedChat.messages.map((message, index) =>
                  message.type === "question" ? (
                    <SenderWidget senderQuestionContent={message.content} key={index} />
                  ) : (
                    <AiResponseWidget AiResponseContent={message.content} AiResponseSources={message.sources}  key={index} />
                  )
                )
              )}
              {selectedChat?.isWaiting && (
                // canceled the loading animation because now we have streaming cursor instead
                // <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-blue-500 m-4 align-left"></div>
                <></>
              )}
            </div>
          </div>
        </div>
        <MessageWidget />
      </main>
    </div>
  );
};

export default Main;
